export default "__VITE_ASSET__005a024a__"